module.exports = __webpack_public_path__ + "media/images/convenios/inst_prov_tabaco-0d08c1768453a48b6f78719661854fae.jpg";